<!--发货地址 弹框
-->
<template>
    <div>
        <e-dialog dialogTitle="发货地址"
                  :centerDialogVisible="shippingAddressVisible"
                  @updateVisible="closeDialog"
                  @resetPopupData="closeDialog"
                  @submitPopupData="submitPopupData"
                  :popupWidth="'800px'">
            <e-table-list
                    maxHeight="800"
                    :loading="loading"
                    :table-data="tableData"
                    :table-label="tableLabel"
              >
                <template v-slot:radio="slot">
                    <el-radio v-model="addressId" :label="slot.scope.row.addressId" @change="chooseAddress(slot.scope.row)"></el-radio>
                 </template>
                <template v-slot:showIndex="slot">
                    {{slot.scope.$index + 1}}
                 </template>
                <template v-slot:address="slot">
                    <e-tooltip :content="slot.scope.row.address" :set-length="10"/>
                </template>
             </e-table-list>
        </e-dialog>
    </div>
</template>

<script>
    import api from "../../../api/order";
    import eDialog from "@/components/common/epecDialog.vue";
    import eTableList from '../../../components/common/e-table-list';
    import eTooltip from "../../../components/common/e-tooltip";

    export default {
        name: "shippingAddressDialog",
        props: {
            shippingAddressVisible: Boolean,
            chooseAddressId:Number,
            tableData:Array,
        },
        components: {
            eDialog,
            eTableList,
            eTooltip
        },
        data() {
            return {
                chooseAddressRow:{},
                addressId:'',
                loading: false,
                tableLabel: [
                    {label: '', param: '', align: 'center',slot:'radio', fixed: "left",width:'35'},
                    {label: '序号', param: '', align: 'center',slot:'showIndex',width:'80'},
                    {label: '发货人', param: 'realName', align: 'center',},
                    {
                        label: '发货地', param: 'location', align: 'center', render: (row) => {
                            return row.province + row.city + row.county;
                        }
                    },
                    {label: '详细地址', param: 'address', align: 'center',slot:'address'},
                    {label: '邮编', param: 'email', align: 'center',},
                    {label: '手机号', param: 'mobile', align: 'center',},
                    {label: '地址类型', param: 'addressType', align: 'center',},
                ],
            }
        },
        methods: {
            chooseAddress(row){
                this.chooseAddressRow = row;
            },
            closeDialog() {
                this.$emit('closeDialog');
            },
            submitPopupData(){
                if(!this.addressId){
                    this.$message.warning('请选择发货地址。');
                    return false;
                }
                this.$emit('submitAddress',this.chooseAddressRow);
            },
            async shipQueryList() {
                let res = await api.shipQueryList();
                if (res.success) {
                    this.tableData = res.data;
                }
            },
        },
        mounted() {
            // this.shipQueryList();
        },
        watch:{
            chooseAddressId:{
                handler: function (val) {
                    if(val){
                        this.addressId = Number(val);
                    }
                },
                deep: true,
                immediate: true
            }
        },

    }
</script>

<style scoped lang="scss">

</style>